export default __webpack_public_path__ + "static/media/frenchLight.fa7bac4e.png";